import React from 'react';
import { Field } from 'redux-form';
import { Skeleton } from '@nike/nike-design-system-components';

import Input from '~COMPONENTS/formInputs/Input';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import {
  handleValidatePrePack,
  validateMinRules,
  validateMaxRules,
  hasValueAndIsPositive,
  lessThanAvailable,
  isNotZero
} from '~APP_UTIL/formValidations';

import { getAvailabilityDisplay } from '../../util/mapAvailability';
import { PDP_QUANTITY_MAXLEN, AVAILABILITY_COLUMNS_BY_SALES_ORG } from '../constants';

const sizeColumn = {
  header: (
    <>
      <TranslatedCopy id='global.size' />
    </>
  ),
  id: 'displaySize',
  cell: ({ displaySize }, { isFtwr }) => {
    return isFtwr ? (
      <div className='ftwr-size-conversion-div'>
        <span className='ftwr-size-conversion-span'>{displaySize}</span>
      </div>
    ) : (
      displaySize
    );
  }
};

const availabilityColumns = [
  {
    header: (
      <>
        <TranslatedCopy id='global.availability.contract' />:
      </>
    ),
    id: 'contract',
    cell: (size, { isAvailabilityRequestLoading }) => {
      const { CONTRACT } = size.availability;

      return isAvailabilityRequestLoading ? (
        <Skeleton height='100%' width='100%' />
      ) : (
        <span className='text-color-secondary'>{CONTRACT}</span>
      );
    }
  },
  {
    header: (
      <>
        <TranslatedCopy id='global.availability.free' />:
      </>
    ),
    id: 'availability',
    cell: (size, { isAvailabilityRequestLoading }) => {
      const { GENERAL } = size.availability;
      const generalAvailability = getAvailabilityDisplay(GENERAL);

      return isAvailabilityRequestLoading ? (
        <Skeleton height='100%' width='100%' />
      ) : (
        <span className='text-color-secondary'>{generalAvailability}</span>
      );
    }
  },
  {
    header: (
      <>
        <TranslatedCopy id='global.availability' />:
      </>
    ),
    id: 'availability',
    cell: (size, { isAvailabilityRequestLoading }) => {
      const { GENERAL, CONTRACT } = size.availability;
      const allAvailability = getAvailabilityDisplay(GENERAL + CONTRACT);

      return isAvailabilityRequestLoading ? (
        <Skeleton height='100%' width='100%' />
      ) : (
        <span className='text-color-secondary'>{allAvailability}</span>
      );
    }
  }
];

const quantity = {
  header: (
    <>
      <TranslatedCopy id='global.quantity' />:
    </>
  ),
  id: 'quantity',
  cell: (size, { selectedProduct, total, min, max }) => (
    <Field
      name={`${size.sizeCode.split('.').join('_')}--${size.code}`}
      type='text'
      component={Input}
      validate={[
        hasValueAndIsPositive,
        lessThanAvailable,
        isNotZero,
        ...[handleValidatePrePack(selectedProduct), validateMinRules(min, total), validateMaxRules(max, total)].filter(
          validation => validation
        )
      ]}
      available={size.availability}
      disabled={size.availability.CONTRACT === 0 && size.availability.GENERAL === 0}
      maxLength={PDP_QUANTITY_MAXLEN}
    />
  )
};

export const getColumnsByOrg = salesOrg => [
  sizeColumn,
  ...availabilityColumns.slice(...(AVAILABILITY_COLUMNS_BY_SALES_ORG.includes(salesOrg) ? [0, 2] : [2])),
  quantity
];
